<template>
    <div id="about-us">
      <van-nav-bar
        :placeholder="true"
        :safe-area-inset-top="true"
        :fixed="true"
        title="关于我们"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      >
        <template #right>
          <van-icon  @click="search" name="search" size="24" />
        </template>
      </van-nav-bar>
      <img style="width: 100%;height: auto" src="https://teamer-online.oss-cn-shenzhen.aliyuncs.com/resource/20220823/qrtest/aboutus.jpg">
      <bottom-nav></bottom-nav>
    </div>
</template>

<script>
import BottomNav from './components/BottomNav';
export default {
  name: 'PreschoolAboutUs',
  components: { BottomNav },
  methods: {
    search () {
      this.$router.push({ name: 'PreschoolSearch' });
    },
    onClickLeft () {
      history.back();
    }
  }
};
</script>

<style scoped>

</style>